import React from 'react';
import styles from './exercise.module.scss';
import { ElementDto } from '../../../../../../../api';
import { EditControlsType, SaveType } from 'modules/course/course.types';

import { ExerciseView } from './ExerciseView';
import { ExerciseEdit } from './ExerciseEdit';
import { ActionTypes } from 'modules/course/state/actions/course/types';
import { useClassName } from 'hooks/use-class-name';

const Wrapper = ({
	children,
	userCanEdit,
}: {
	children: React.ReactNode;
	userCanEdit?: boolean;
}) => {
	const classNames = useClassName(
		styles.exercise,
		userCanEdit && styles.editable,
	);

	return <div className={classNames}>{children}</div>;
};

type ExerciseProps = {
	chapterId: string;
	pageId: string;
	element: ElementDto;
	editControls: EditControlsType;
	save: SaveType;
	changeElement: ActionTypes['changeElement'];
	deleteElement: ActionTypes['deleteElement'];
};

export function Exercise({
	chapterId,
	pageId,
	element,
	editControls,
	save,
	changeElement,
	deleteElement,
}: ExerciseProps) {
	const { setEditMode, leaveEditMode, editMode, userCanEdit } = editControls(
		element.id,
	);

	const handleChangeElement = (content: string) => {
		changeElement(chapterId, pageId, element.id, content);
	};

	const handleDeleteElement = () => {
		deleteElement(chapterId, pageId, element.id);
		save(element.id);
	};

	if (editMode) {
		return (
			<Wrapper>
				<ExerciseEdit
					name={element.id}
					text={element.indhold}
					changeElement={handleChangeElement}
					deleteElement={handleDeleteElement}
					element={element}
					leaveEditMode={leaveEditMode}
					save={save}
				/>
			</Wrapper>
		);
	}

	return (
		<Wrapper userCanEdit={userCanEdit}>
			<ExerciseView
				userCanEdit={userCanEdit}
				setEditMode={setEditMode}
				text={element.indhold}
				name={element.id}
			/>
		</Wrapper>
	);
}
